import React from "react";
import { BrandLogo } from "../../../../ui";

export function SidebarLogo() {
  const handleClick = () => {
    window.location.href = "/";
  };

  return (
    <BrandLogo
      className="mr-4 h-6 m-2 my-8 mt-6 hover:cursor-pointer"
      onClick={handleClick}
    />
  );
}
